import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { useEffect } from "react";

const LanguageRedirectEn = () => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    i18n.changeLanguage("en");
    document.documentElement.lang = "en";
    document.documentElement.dir = "ltr";
    navigate("/", { replace: true });
  }, [i18n, navigate]);

  return (
    <div className="flex items-center justify-center h-screen">
      <div className="text-center">
        <div className="text-lg">Switching to English...</div>
        <div className="text-sm text-gray-500 mt-2">
          جاري التبديل إلى الإنجليزية...
        </div>
      </div>
    </div>
  );
};

export default LanguageRedirectEn;
